(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.factory('AgendaOverviewService', ['$state', 'AppointmentTypeService', 'DownloadService', 'ExportFormat', 'SharedAgendaService', 'AgendaService', 'DateService', '$uibModal', AgendaOverviewServiceFn]);

    // main overview service for agenda-specific actions
    function AgendaOverviewServiceFn($state, AppointmentTypeService, DownloadService, ExportFormat, SharedAgendaService, AgendaService, DateService, $uibModal) {
        // main data
        var data = {
            cutCopyInProgress: false, // vm 
            copy: false, // intern
            cut: false, // intern
            timeToPaste: null, // object to paste
            agendas: [], // list of user id to show     
            numberOfAgendas: 0, // number of agendas in ffa fe
            weekView: false,
            modalInstance: null,
            appointmentId: null,
            agendaId: null
        };

        var service = {
            data: data,
            clear: clear,
            copying: copying,
            cutting: cutting,
            showAgendaPerDay: showAgendaPerDay,
            showPrintModal: showPrintModal
        };

        // print information
        function showPrintModal(scope, appointmentId, agendaId) {
            data.appointmentId = appointmentId;
            data.agendaId = agendaId;
            
            // select the first option of printing
            scope.printLayout = 0;
            scope.closePrintModalAndPrint = closePrintModalAndPrint;
            scope.closePrintModal = closePrintModal;
            // open modal for chosing if label or prescription should be printed
            data.modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/agenda/templates/agenda-appointment-print-modal.template.html',
                scope: scope,
                size: 'md'
            });
        }

        function closePrintModal(){
            if (data.modalInstance !== null) {
                data.modalInstance.dismiss();
            }
        }

        // print
        function closePrintModalAndPrint (selectedLayout) {
            if (data.modalInstance !== null) {
                data.modalInstance.dismiss();
            }
            if (data.appointmentId)
            {
                let exportFormat = ExportFormat.PDF.value;
                // check if selected layout is prescription or label       
                let printPrescription = selectedLayout === 0 || selectedLayout === 1;
                if (selectedLayout === 1)
                {
                    exportFormat = ExportFormat.WORD.value;
                }
                let agenda = SharedAgendaService.getAgenda(data.agendaId);

                DownloadService.exportAppointment(data.appointmentId, agenda.owner.id, agenda.id, printPrescription,exportFormat).then(function (response) {
                    DownloadService.openReport(exportFormat, response, "appointment");
                });
            }
            
        }

        // clear
        function clear() {
            data.cutCopyInProgress = false;
            data.timeToPaste = null;
            data.copy = false;
            data.cut = false;
            data.agendas = [];
        }

        // start copy progress
        function copying(time) {
            clear();
            data.cutCopyInProgress = true;
            data.copy = true;
            data.timeToPaste = time;
        }

        // start cut progress
        function cutting(time) {
            clear();
            data.cutCopyInProgress = true;
            data.cut = true;
            data.timeToPaste = time;
        }


        // go to agenda-per-day
        function showAgendaPerDay(date) {
            DateService.dateAndBroadcast(new Date(date)).then(function () {
                $state.go("Home.Agenda_Day", { today: false }, { reload: $state.current });
            });
        } // showAgendaPerDay


        return service;

    }
})();